<template>
  <div>
    <Navbar />
    <section class="bg-half-170 d-table w-100 overflow-hidden">
      <div class="container">
        <div class="row align-items-center pt-5">
          <div class="col-12">
            <h1>{{ $t("cookiesPolicy:page.title") }}</h1>

            <p>
              {{ $t("cookiesPolicy:page.p_1") }}
            </p>

            <p>
              <strong>{{ $t("cookiesPolicy:page.p_2") }}</strong>
            </p>

            <p>
              {{ $t("cookiesPolicy:page.p_3") }}
            </p>

            <p>
              {{ $t("cookiesPolicy:page.p_4_1") }}
              <a href="https://www.privacypolicyonline.com/what-are-cookies/">
                {{ $t("cookiesPolicy:page.p_4_1_href") }}</a
              >
              {{ $t("cookiesPolicy:page.p_4_2") }}
              <a href="https://www.generateprivacypolicy.com/">{{
                $t("cookiesPolicy:page.p_4_2_href")
              }}</a
              >.
            </p>

            <p>
              <strong>{{ $t("cookiesPolicy:page.p_5") }}</strong>
            </p>

            <p>
              {{ $t("cookiesPolicy:page.p_6") }}
            </p>

            <p>
              <strong>{{ $t("cookiesPolicy:page.p_7") }}</strong>
            </p>

            <p>
              {{ $t("cookiesPolicy:page.p_8") }}
              <a
                href="https://www.cookiepolicygenerator.com/cookie-policy-generator/"
                >{{ $t("cookiesPolicy:page.p_8_href") }}</a
              >.
            </p>
            <p>
              <strong>{{ $t("cookiesPolicy:page.first_list.title") }}</strong>
            </p>

            <ul>
              <li>
                <p>{{ $t("cookiesPolicy:page.first_list.p_1") }}</p>
                <p>
                  {{ $t("cookiesPolicy:page.first_list.p_2") }}
                </p>
              </li>

              <li>
                <p>{{ $t("cookiesPolicy:page.first_list.p_3") }}</p>
                <p>
                  {{ $t("cookiesPolicy:page.first_list.p_4") }}
                </p>
              </li>

              <li>
                <p>{{ $t("cookiesPolicy:page.first_list.p_5") }}</p>
                <p>
                  {{ $t("cookiesPolicy:page.first_list.p_6") }}
                </p>
              </li>

              <li>
                <p>{{ $t("cookiesPolicy:page.first_list.p_7") }}</p>
                <p>
                  {{ $t("cookiesPolicy:page.first_list.p_8") }}
                </p>
              </li>

              <li>
                <p>{{ $t("cookiesPolicy:page.first_list.p_9") }}</p>
                <p>
                  {{ $t("cookiesPolicy:page.first_list.p_10") }}
                </p>
              </li>

              <li>
                <p>{{ $t("cookiesPolicy:page.first_list.p_11") }}</p>
                <p>
                  {{ $t("cookiesPolicy:page.first_list.p_12") }}
                </p>
              </li>
            </ul>

            <p>
              <strong>{{ $t("cookiesPolicy:page.second_list.title") }}</strong>
            </p>

            <p>
              {{ $t("cookiesPolicy:page.second_list.subtitle") }}
            </p>

            <ul>
              <li>
                <p>
                  {{ $t("cookiesPolicy:page.second_list.p_1") }}
                </p>
                <p>
                  {{ $t("cookiesPolicy:page.second_list.p_2") }}
                </p>
              </li>

              <li>
                <p>
                  {{ $t("cookiesPolicy:page.second_list.p_3") }}
                </p>
              </li>

              <li>
                <p>
                  {{ $t("cookiesPolicy:page.second_list.p_4") }}
                </p>
              </li>

              <li>
                <p>
                  {{ $t("cookiesPolicy:page.second_list.p_5") }}
                </p>
              </li>

              <li>
                <p>
                  {{ $t("cookiesPolicy:page.second_list.p_6") }}
                </p>
              </li>

              <li>
                <p>
                  {{ $t("cookiesPolicy:page.second_list.p_7") }}
                </p>
              </li>
            </ul>

            <p>
              <strong>{{ $t("cookiesPolicy:page.third_list.title") }}</strong>
            </p>

            <p>
              {{ $t("cookiesPolicy:page.third_list.subtitle") }}
            </p>

            <p>
              {{ $t("cookiesPolicy:page.third_list.subtitle_2") }}
            </p>

            <ul>
              <li>{{ $t("cookiesPolicy:page.third_list.p_1") }}</li>
              <li>{{ $t("cookiesPolicy:page.third_list.p_2") }}</li>
              <li>{{ $t("cookiesPolicy:page.third_list.p_3") }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>
<script>
import Navbar from "@/components/landing_landrick/navbar";
import Footer from "@/components/landing_landrick/footer";
export default {
  name: "cookies-policy",
  data() {
    return {};
  },
  components: {
    Navbar,
    Footer
  }
};
</script>
